import styled from 'styled-components';

export const ContainerPermissions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PermissionsSummary = styled.div`
  padding: 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;

  p {
    margin: 0;
    color: #475569;
    line-height: 1.5;
  }
`;

export const PermissionsLegend = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-top: 12px;
`;

export const PermissionsLegendItem = styled.div`
  padding: 12px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #dbe4ee;

  strong {
    display: block;
    color: #0f172a;
    font-size: 14px;
    margin-bottom: 4px;
  }

  span {
    color: #64748b;
    font-size: 13px;
    line-height: 1.4;
  }
`;

export const PermissionsGrid = styled.div`
  max-height: 560px;
  overflow-y: auto;
  padding-right: 4px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
`;

export const PermissionSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const PermissionSectionCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 74px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;

  &:hover {
    background: #dbeafe;
  }
`;

export const PermissionSectionDescription = styled.p`
  margin: 0 0 12px;
  color: #64748b;
  line-height: 1.5;
`;

export const PermissionsSummaryHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 4px;

  strong {
    flex: 1;
    color: #0f172a;
    font-size: 16px;
  }
`;

export const PermissionsSummaryActions = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;

  button {
    padding: 4px 12px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    background: #ffffff;
    color: #334155;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition:
      background 0.15s,
      border-color 0.15s;

    &:hover {
      background: #eff6ff;
      border-color: #3b82f6;
      color: #1d4ed8;
    }
  }
`;
